import React, { Component } from "react";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

const Search = styled("div")(({ theme }) => ({
	position: "relative",
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(theme.palette.common.white, 0.15),
	"&:hover": {
		backgroundColor: alpha(theme.palette.common.white, 0.25),
	},
	marginLeft: 0,
	width: "100%",
	height: "24px",
	[theme.breakpoints.up("sm")]: {
		marginLeft: theme.spacing(1),
		width: "auto",
	},
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
	padding: theme.spacing(0, 2),
	height: "100%",
	position: "absolute",
	pointerEvents: "none",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
	color: "inherit",
	height: "24px",
	"& .MuiInputBase-input": {
		padding: theme.spacing(0.5, 0.5, 0.5, 0),
		paddingLeft: `calc(1em + ${theme.spacing(4)})`,
		transition: theme.transitions.create("width"),
		width: "100%",
		fontSize: "0.875rem",
	},
}));

class SearchField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: "",
		};
	}

	search() {
		if (this.props.onSearch) {
			this.props.onSearch(this.state.text);
		}
	}

	render() {
		const { onClick, placeholder } = this.props;
		return (
			<Search>
				<SearchIconWrapper>
					<SearchIcon />
				</SearchIconWrapper>
				<StyledInputBase
					placeholder={placeholder || "Search..."}
					onClick={onClick}
					onChange={(event) => {
						this.setState({
							text: event.target.value,
						});
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							this.search();
						}
					}}
				/>
			</Search>
		);
	}
}

export default SearchField;
